/* Component on the LatestsPage to display the post cover data
 * When clicked on it opens that Post's LatestPage */
import React, { useEffect, useState } from "react"
import Card from "react-bootstrap/Card"
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import styles from "../../styles/Post.module.css"
import { useCurrentUser } from "../../contexts/CurrentUserContext"
import { Link, useHistory } from "react-router-dom"
import Avatar from "../../components/Avatar"
import { axiosInstance, axiosRes } from "../../api/axiosDefaults"
import { PostDropdown } from "../../components/PostDropdown"
import { CLIENT_PROGRAM_HOSTNAME } from "../../utils/config"
import useHostName from "../../hooks/useHostName"
import toast from "react-hot-toast";

const LatestTop = (props) => {
  const [showActionMenu, setShowActionMenu] = useState(true); 
  const {
    fetchPosts,
    id,
    // owner,
    name,
    profile_id,
    profile_image,
    position,
    opened_id,
    title,
    departments,
    updated_at,
    setPosts,
  } = props

  const host = useHostName()
  const currentUser = useCurrentUser()
  const history = useHistory();

  useEffect(() => {
        if (
          currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name === "Admincreative" ||
            currentUser?.groups[0]?.name === "Crew")
        ) {
          // now check where the post is His own post or NOT
          if (Number(profile_id) !== Number(currentUser?.profile_id)) {
            setShowActionMenu(false);
          }
        } else {
          if (
            currentUser &&
            currentUser?.groups.length > 0 &&
            currentUser?.groups[0]?.name === "Cast"
          ) {
            // Never show the menu
            setShowActionMenu(false);
          }
        }
      }, [profile_id, currentUser]);

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/latest/post/${id}/edit`
    )
  }

  const handleDelete = async () => {
    /* Direct request to DRF departments app URL so 
           department is used  */
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        await axiosRes.delete(`/department/posts/${id}/`)
        toast.success(`Post Deleted`);
        fetchPosts();
      } else {
        await axiosInstance.delete(
          `${localStorage.getItem("projectSlug")}/department/posts/${id}/`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        toast.success(`Post Deleted Successfully!`);
        fetchPosts();
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handleDeptOpened = async () => {
    /* Function to create an instance in the openedDept table
           for the post */
    // console.log("openeddeptlatest")
    try {
      if (host === CLIENT_PROGRAM_HOSTNAME) {
        const { data } = await axiosRes.post("/openedDept/", { post: id })
        setPosts((prevPosts) => ({
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id ? { ...post, opened_id: data.id } : post
          }),
        }))
      } else {
        const { data } = await axiosInstance.post(
          `${localStorage.getItem("projectSlug")}/openedDept/`,
          { post: id },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
            withCredentials: true,
          }
        )
        setPosts((prevPosts) => ({
          ...prevPosts,
          results: prevPosts.results.map((post) => {
            return post.id === id ? { ...post, opened_id: data.id } : post
          }),
        }))
      }
    } catch (err) {
      console.log(err)
    }
  }

  return (
    <div>
    <Card className={ `py-0 my-0 mb-0`}>
    <Card.Body className={`py-0 my-0 px-0 ${styles.PostTop}`}>
      <Row className={`d-flex align-items-center pt-0 pb-0 my-0`}>
      <Col xs={12} md={3} className="my-0" >
          {/* small */}
          <div className='d-none d-md-block'>
          <Row className={`d-flex align-items-center pt-0 pb-0 my-0`}>
          <Col xs={3} className="pl-3 pr-0">
            <Link
              to={`/${localStorage.getItem(
                "projectSlug"
              )}/profiles/${profile_id}`}
            >
              <Avatar src={profile_image} height={45} />
            </Link>
          </Col>
          <Col xs={9} className="pl-3 pl-md-2 pr-0" >
          <div className={`${styles.Content4} pl-2 ml-2`}>
          <p className={`${styles.WhiteName}`}>{name}
          </p>
          <p className={`${styles.Posit}`}>{position}
          </p>
          </div>
          <div>
          </div>
          </Col>
          </Row>   
          </div>     
          {/* mobile */}
          <div className='d-md-none'>
          <Row className='pb-0 mb-0 d-flex align-items-center pt-1'>
          <Col className="pb-0" xs={2}>
            <Link
              to={`/${localStorage.getItem(
                "projectSlug"
              )}/profiles/${profile_id}`}
            >
              <Avatar src={profile_image} height={30} />
            </Link>
          </Col>
          <Col xs={8} className="text-center" >
          <div className={`${styles.NamePosMo}`}>
          <p >
            {name}
            <span style={{ textTransform: "capitalize" }} 
          className={`${styles.Posit} ml-2`}>{position}
          </span>
          </p>
          </div>
          <p className={ `text-center  ${styles.Date}`}>{updated_at}
          </p>
          </Col>
          <Col xs={2} 
          className="d-flex align-items-center" >
          {showActionMenu && (
          <PostDropdown
              handleEdit={handleEdit}
              handleDelete={handleDelete}
          />
          ) } 
          </Col>
          </Row> 
          </div> 
      </Col> 
      <Col xs={12} md={6} className="py-1" >
      {/* mine */}
      <Link
          to={`/${localStorage.getItem("projectSlug")}/latest/post/${id}`}
        >
      {opened_id ? (
        <Row className={`${styles.ContentOpened} py-0 my-0 mr-1 ml-1`}>
        <Col xs={12} 
        className={` text-center`} >
        <Row>
        <Col className='px-0 mx-0' xs={12}>
            {departments && <p style={{ textTransform: 'capitalize' }}>
              {departments}</p>}
          </Col>
        </Row>
        <Row>
        <Col xs={12} className={`text-center px-0 mx-0 ${styles.Content4}`} >
        {title && <span className={`text-center px-0 mx-0 ${styles.ContentTitleOpened}`}
            style={{ fontStyle: 'italic' }}> {title}</span>}
        </Col>
        </Row>
        </Col>
        </Row>
      ) : (
        <Row onClick={handleDeptOpened}
            className={`${styles.ContentUnOpen} py-0 my-0 mr-1 ml-1`}>
          <Col xs={12} 
          className={` text-center`} >
          <Row>
          <Col className='px-0 mx-0' xs={12}>
            {departments && <p style={{ textTransform: 'capitalize'}}>
              {departments}</p>}
          </Col>
          </Row>
          <Row>
          <Col xs={12} className={`text-center px-0 mx-0 ${styles.Content4}`} >
          {title && <span className={`text-center px-0 mx-0 ${styles.ContentTitleUnOpen}`}
            style={{ fontStyle: 'italic' }}> {title}</span>}
          </Col>
          </Row>
          </Col>
          </Row>
      )}
      </Link>
      </Col>
      {/* edit and date small */}
      <Col xs={12} md={3} className="my-0 " >
      <div className='d-none d-md-block'>
      <Row className="d-flex align-items-center px-0">
      <Col className="pl-0 pr-0" sm={10} >
      <p className={ `text-center  ${styles.Date}`}>{updated_at}
      </p>
      </Col>
      <Col sm={2} className="d-flex align-items-center px-0 float-right" >
      {showActionMenu && (
      <PostDropdown
          handleEdit={handleEdit}
          handleDelete={handleDelete}
      />
      ) } 
      </Col>
      </Row>   
      </div>     
      </Col>
      </Row>
    </Card.Body>
    </Card>
  </div>
  )
}

export default LatestTop
